import { useMemo } from 'react'

import { NotificationVerb } from 'src/shared/schemas/notifications'

type LynkWorkflowSubtitleProps = {
  notificationVerb: NotificationVerb
}

const LynkWorkflowSubtitle = ({ notificationVerb }: LynkWorkflowSubtitleProps) => {
  const text = useMemo(() => {
    if (!notificationVerb) {
      return null
    }
    if (notificationVerb === NotificationVerb.TWILIO_BRAND_FAILED) {
      return 'Update your info to finish registration.'
    } else if (notificationVerb === NotificationVerb.TWILIO_CAMPAIGN_FAILED) {
      return null
    } else if (notificationVerb === NotificationVerb.TWILIO_NUMBER_SELECTION) {
      return 'Choose your number to start connecting with leads.'
    }
    return null
  }, [notificationVerb])

  if (!text) return null

  return <p className="text-[13px] leading-[18px] text-muted">{text}</p>
}

export default LynkWorkflowSubtitle
